// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.7_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.7_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-color: #FF4900;
  --primary-color: #FFFFFF;
  --secondary-color: #6b6b6b;
  --primary-bg-color: #000000;
  --secondary-bg-color: #111111;
  --bg-color: #060606;
  --primary-border-color: #707070;
  --secondary-border-color: #333333;
  --filter-bg: none;
}
[data-theme="light"] {
  --primary-color: #000000;
  --secondary-color: #444444;
  --primary-bg-color: #FFFFFF;
  --secondary-bg-color: #F5F5F5;
  --bg-color: #FAFAFA;
  --primary-border-color: #CCCCCC;
  --secondary-border-color: #EEEEEE;
  --filter-bg: grayscale(100%) brightness(100%);
}
html {
  scroll-behavior: smooth;
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
}
* {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, filter 0.3s ease;
}
body {
  background-color: var(--primary-bg-color);
  color: var(--primary-color);
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  line-height: 35px;
}
a {
  color: var(--primary-color);
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
.basic-container {
  max-width: 1510px;
  padding: 0 30px;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .basic-container {
    padding: 0 20px;
  }
}
svg {
  font-family: "Poppins", sans-serif;
  width: 200px;
  height: 80px;
}
@media (max-width: 768px) {
  svg {
    width: 150px;
    height: 60px;
  }
}
header#top-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 120px;
  position: relative;
}
@media (max-width: 1024px) {
  header#top-header {
    height: 80px;
    justify-content: space-between;
  }
}
header#top-header div#logo {
  height: 100%;
  display: flex;
  align-items: flex-end;
}
@media (max-width: 1024px) {
  header#top-header div#logo {
    align-items: center;
  }
}
header#top-header .burger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  cursor: pointer;
  z-index: 1001;
}
@media (max-width: 1024px) {
  header#top-header .burger-menu {
    display: flex;
  }
}
header#top-header .burger-menu span {
  width: 100%;
  height: 3px;
  background-color: var(--primary-color);
  transition: all 0.3s ease;
}
header#top-header .burger-menu.active span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}
header#top-header .burger-menu.active span:nth-child(2) {
  opacity: 0;
}
header#top-header .burger-menu.active span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}
header#top-header div#navigation-links {
  flex-grow: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}
@media (max-width: 1024px) {
  header#top-header div#navigation-links {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background-color: var(--primary-bg-color);
    flex-direction: column;
    justify-content: center;
    transition: right 0.3s ease;
    z-index: 1000;
    padding: 50px 0;
  }
  header#top-header div#navigation-links.active {
    right: 0;
  }
}
header#top-header div#navigation-links ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  height: 100%;
}
@media (max-width: 1024px) {
  header#top-header div#navigation-links ul {
    flex-direction: column;
    height: auto;
    margin-bottom: 30px;
  }
}
header#top-header div#navigation-links ul li {
  width: 140px;
  padding: 0 0 30px 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media (max-width: 1024px) {
  header#top-header div#navigation-links ul li {
    width: 100%;
    padding: 20px 0;
    align-items: center;
  }
}
@media (max-width: 768px) {
  header#top-header div#navigation-links ul li {
    width: auto;
    padding: 15px 0;
  }
}
header#top-header div#navigation-links ul li.selected {
  background-color: var(--brand-color);
}
header#top-header #hire-me-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
@media (max-width: 1024px) {
  header#top-header #hire-me-container {
    display: none;
  }
}
header#top-header #language-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
  padding-top: 25px;
  margin-left: 50px;
  color: var(--secondary-color);
}
@media (max-width: 1024px) {
  header#top-header #language-selection {
    margin-left: 0;
    padding-top: 0;
    margin-bottom: 20px;
    height: auto;
  }
}
header#top-header #language-selection span {
  font-size: 18px;
  cursor: pointer;
}
header#top-header #language-selection span:hover {
  color: var(--primary-color);
}
header#top-header #theme-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 35px;
  margin-left: 20px;
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 18px;
  width: 35px;
  text-align: center;
}
@media (max-width: 1024px) {
  header#top-header #theme-selection {
    margin-left: 0;
    padding-top: 0;
    height: auto;
  }
}
header#top-header #theme-selection:hover {
  color: var(--primary-color);
}
button {
  border-radius: 10px;
  border: 2px solid var(--brand-color);
  background-color: var(--brand-color);
  color: var(--primary-color);
  width: 150px;
  padding: 23px 0px;
  align-self: flex-end;
}
@media (max-width: 768px) {
  button {
    width: 120px;
    padding: 15px 0;
    font-size: 14px;
  }
}
button#hire-me-button {
  margin-left: 35px;
  margin-bottom: 5px;
}
@media (max-width: 768px) {
  button#hire-me-button {
    margin-left: 10px;
  }
}
#hero-section {
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
@media (max-width: 1024px) {
  #hero-section {
    min-height: auto;
    padding: 100px 0;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
#hero-section #hero-text {
  flex: 1;
  z-index: 1;
}
#hero-section #hero-canvas-container {
  flex: 1;
  height: 600px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1024px) {
  #hero-section #hero-canvas-container {
    height: 400px;
    position: absolute;
    z-index: -1;
  }
}
@media (max-width: 768px) {
  #hero-section #hero-canvas-container {
    height: 300px;
  }
}
#hero-section #hero-canvas-container canvas {
  max-width: 100%;
  max-height: 100%;
}
#hero-section .annotation {
  position: relative;
  font-size: 24px;
  margin-bottom: 10px;
  width: 200px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: var(--brand-color);
}
@media (max-width: 768px) {
  #hero-section .annotation {
    font-size: 18px;
    width: 150px;
    height: 40px;
    line-height: 40px;
  }
}
#hero-section .annotation::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateY(-10%) translateX(-50%) rotate(90deg);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 20px solid var(--brand-color);
}
#hero-section h1 {
  font-size: 80px;
  margin: 25px 0;
}
@media (max-width: 1024px) {
  #hero-section h1 {
    font-size: 60px;
  }
}
@media (max-width: 768px) {
  #hero-section h1 {
    font-size: 40px;
  }
}
#hero-section p {
  font-size: 20px;
  margin: 10px 0 30px 0;
}
@media (max-width: 768px) {
  #hero-section p {
    font-size: 16px;
  }
}
#hero-section #scroll-down-indicator {
  position: absolute;
  bottom: 0px;
  right: 50%;
  transform: translateX(50%) translateY(-20%);
}
@media (max-width: 1024px) {
  #hero-section #scroll-down-indicator {
    display: none;
  }
}
#about-me {
  padding: 200px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}
@media (max-width: 1024px) {
  #about-me {
    flex-direction: column;
    padding: 100px 0;
    align-items: center;
  }
}
#about-me .picture {
  position: relative;
}
#about-me img {
  filter: grayscale(100%);
}
@media (max-width: 1024px) {
  #about-me img {
    width: 100%;
    max-width: 500px;
    margin-bottom: 50px;
  }
}
#about-me .title {
  font-size: 36px;
  margin-bottom: 20px;
  font-weight: bold;
}
@media (max-width: 768px) {
  #about-me .title {
    font-size: 28px;
  }
}
#about-me p {
  font-size: 20px;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}
@media (max-width: 768px) {
  #about-me p {
    font-size: 16px;
  }
}
#about-me .experience-badge {
  background-color: var(--secondary-bg-color);
  color: var(--primary-color);
  width: 220px;
  height: 200px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-size: 40px;
  font-weight: bold;
  padding: 45px;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-25%);
  transition: all 0.3s ease;
}
@media (max-width: 1024px) {
  #about-me .experience-badge {
    transform: none;
    margin: 30px 0;
    width: 180px;
    height: 160px;
    padding: 30px;
    font-size: 30px;
    bottom: 0;
    left: unset;
    right: 0;
    transform: translateX(25%);
  }
}
@media (max-width: 768px) {
  #about-me .experience-badge {
    transform: none;
    margin: 30px 0;
    width: 140px;
    height: 120px;
    padding: 20px;
    font-size: 22px;
    bottom: 0;
    left: unset;
    right: 0;
    transform: translateX(-25%) translateY(25%);
  }
}
#about-me .experience-badge h3 {
  font-size: 50px;
  margin: 30px 0 10px 0;
}
@media (max-width: 1024px) {
  #about-me .experience-badge h3 {
    font-size: 40px;
    margin: 20px 0 5px 0;
  }
}
#about-me .experience-badge .dots-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: calc(100% - 90px);
  top: 0px;
}
@media (max-width: 1024px) {
  #about-me .experience-badge .dots-row {
    width: calc(100% - 60px);
  }
}
#about-me .experience-badge .dots-row span {
  width: 20px;
  height: 45px;
  background-color: var(--primary-color);
}
@media (max-width: 1024px) {
  #about-me .experience-badge .dots-row span {
    width: 15px;
    height: 30px;
  }
}
#about-me .skills {
  scroll-margin-top: 80px;
  /* set to your header height */
  display: flex;
  height: 100%;
  min-height: 100%;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 70px;
}
@media (max-width: 1024px) {
  #about-me .skills {
    padding: 0;
    width: 100%;
    margin-top: 50px;
    justify-content: flex-start;
    align-items: center;
  }
}
#about-me .skills .skills-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}
#about-me .skills .skills-list .skill-item {
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 40px;
}
@media (max-width: 1024px) {
  #about-me .skills .skills-list .skill-item {
    font-size: 16px;
    margin-bottom: 25px;
    padding: 0 25px;
  }
}
#about-me .skills .skills-list .skill-item .skill-bar {
  width: 100%;
  height: 5px;
  background-color: var(--secondary-border-color);
  overflow: hidden;
  margin-top: 30px;
}
@media (max-width: 768px) {
  #about-me .skills .skills-list .skill-item .skill-bar {
    margin-top: 15px;
  }
}
#about-me .skills .skills-list .skill-item .skill-bar .skill-level {
  height: 100%;
}
#about-me .skills .button-section {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
}
@media (max-width: 768px) {
  #about-me .skills .button-section {
    flex-direction: column;
    width: 100%;
    align-items: stretch;
  }
}
#about-me .skills .button-section button {
  width: 240px;
}
@media (max-width: 768px) {
  #about-me .skills .button-section button {
    width: 100%;
  }
}
#about-me .skills .button-section button.secondary-button {
  background-color: transparent;
  border: 2px solid;
  border-color: var(--primary-color);
}
#contact-section {
  background-color: var(--bg-color);
  margin-top: 100px;
  scroll-margin-top: 80px;
}
@media (max-width: 1024px) {
  #contact-section {
    margin-top: 0px;
  }
}
#contact-section > div:first-child {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 1024px) {
  #contact-section > div:first-child {
    flex-direction: column;
  }
}
#contact-section > div:first-child > section {
  padding: 50px 0;
}
@media (max-width: 1024px) {
  #contact-section > div:first-child > section {
    padding: 50px 20px;
  }
}
#contact-section > div:first-child .contact-image {
  width: 50%;
  height: auto;
}
@media (max-width: 1024px) {
  #contact-section > div:first-child .contact-image {
    width: 100%;
    height: 300px;
  }
}
#contact-section > div:first-child .contact-image img {
  object-fit: cover;
  object-position: center;
  filter: grayscale(100%);
  height: 100%;
  width: 100%;
}
#contact-section .contact-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
}
#contact-section .contact-row > div:last-child {
  min-width: 0;
  flex: 1;
}
#contact-section .contact-row .contact-icon {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--secondary-border-color);
}
#contact-section .contact-row .contact-title {
  font-size: 18px;
  color: var(--secondary-color);
  line-height: 18px;
}
#contact-section .contact-row .contact-text {
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  word-wrap: break-word;
  max-width: 100%;
  line-height: 1.4;
}
@media (max-width: 768px) {
  #contact-section .contact-row .contact-text {
    font-size: 18px;
  }
}
@media (max-width: 360px) {
  #contact-section .contact-row .contact-text {
    font-size: 16px;
  }
}
.policy-notice {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 60px;
  padding: 30px;
  border-radius: 12px;
  background-color: var(--secondary-bg-color);
  border: 1px solid var(--secondary-border-color);
  font-size: 18px;
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 60px);
  max-width: 1510px;
  z-index: 1000;
}
.policy-notice p {
  margin: 0;
  flex: 1;
}
.policy-notice a {
  font-weight: 600;
  text-decoration: underline;
}
.policy-notice button[data-policy-ack] {
  width: auto;
  padding: 12px 32px;
  align-self: flex-start;
}
@media (max-width: 768px) {
  .policy-notice button[data-policy-ack] {
    align-self: center;
  }
}
@media (max-width: 1024px) {
  .policy-notice {
    flex-direction: column;
    text-align: center;
  }
}
.policy-notice--hidden {
  display: none;
}
footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background-color: var(--bg-color);
  font-weight: lighter;
}
@media (max-width: 768px) {
  footer {
    font-size: 14px;
    text-align: center;
    padding: 0 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.less","webpack://./src/styles/index.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iBAAA;ACCF;ADEA;EACE,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;EACA,iCAAA;EACA,6CAAA;ACAF;AAlBA;EACE,uBAAA;AAoBF;AAjBA;EACE;IACE,qBAAA;EAmBF;AACF;AAhBA;EACE,iGAAA;AAkBF;AAdA;EACE,yCAAA;EACA,2BAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;AAgBF;AAbA;EACE,2BAAA;EACA,qBAAA;AAeF;AAbE;EACE,qBAAA;AAeJ;AAXA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAaF;AAXE;EAAA;IACE,eAAA;EAcF;AACF;AAXA;EACE,kCAAA;EACA,YAAA;EACA,YAAA;AAaF;AAXE;EAAA;IACE,YAAA;IACA,YAAA;EAcF;AACF;AAXA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAaF;AAXE;EAAA;IACE,YAAA;IACA,8BAAA;EAcF;AACF;AAxBA;EAaI,YAAA;EACA,aAAA;EACA,qBAAA;AAcJ;AAZI;EAAA;IACE,mBAAA;EAeJ;AACF;AAlCA;EAuBI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAcJ;AAZI;EAAA;IACE,aAAA;EAeJ;AACF;AAhDA;EAoCM,WAAA;EACA,WAAA;EACA,sCAAA;EACA,yBAAA;AAeN;AAZI;EAEI,wCAAA;AAaR;AAfI;EAKI,UAAA;AAaR;AAlBI;EAQI,0CAAA;AAaR;AA/DA;EAwDI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAUJ;AARI;EAAA;IACE,eAAA;IACA,MAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,yCAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,aAAA;IACA,eAAA;EAWJ;EATI;IACE,QAAA;EAWN;AACF;AAzFA;EAkFM,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AAUN;AARM;EAAA;IACE,sBAAA;IACA,YAAA;IACA,mBAAA;EAWN;AACF;AAvGA;EA+FQ,YAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AAWR;AATQ;EAAA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;EAYR;AACF;AAVQ;EAAA;IACE,WAAA;IACA,eAAA;EAaR;AACF;AAXQ;EACE,oCAAA;AAaV;AA9HA;EAwHI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AASJ;AAPI;EAAA;IACE,aAAA;EAUJ;AACF;AAzIA;EAmII,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;AASJ;AAPI;EAAA;IACE,cAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;EAUJ;AACF;AARI;EACE,eAAA;EACA,eAAA;AAUN;AARM;EACE,2BAAA;AAUR;AAlKA;EA8JI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAOJ;AALI;EAAA;IACE,cAAA;IACA,cAAA;IACA,YAAA;EAQJ;AACF;AANI;EACE,2BAAA;AAQN;AAHA;EACE,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAKF;AAHE;EAAA;IACE,YAAA;IACA,eAAA;IACA,eAAA;EAMF;AACF;AAHA;EACE,iBAAA;EACA,kBAAA;AAKF;AAHE;EAAA;IACE,iBAAA;EAMF;AACF;AAHA;EACE,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAKF;AAHE;EAAA;IACE,gBAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;EAMF;AACF;AApBA;EAiBI,OAAA;EACA,UAAA;AAMJ;AAxBA;EAsBI,OAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAKJ;AAHI;EAAA;IACE,aAAA;IACA,kBAAA;IACA,WAAA;EAMJ;AACF;AAJI;EAAA;IACE,aAAA;EAOJ;AACF;AA5CA;EAwCM,eAAA;EACA,gBAAA;AAON;AAhDA;EA8CI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;AAKJ;AAHI;EAAA;IACE,eAAA;IACA,YAAA;IACA,YAAA;IACA,iBAAA;EAMJ;AACF;AAJI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0DAAA;EAGA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,0CAAA;AAIN;AA9EA;EA+EI,eAAA;EACA,cAAA;AAEJ;AAAI;EAAA;IACE,eAAA;EAGJ;AACF;AADI;EAAA;IACE,eAAA;EAIJ;AACF;AA5FA;EA2FI,eAAA;EACA,qBAAA;AAIJ;AAFI;EAAA;IACE,eAAA;EAKJ;AACF;AArGA;EAoGI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,2CAAA;AAIJ;AAFI;EAAA;IACE,aAAA;EAKJ;AACF;AAoBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAlBF;AAoBE;EAAA;IACE,sBAAA;IACA,gBAAA;IACA,mBAAA;EAjBF;AACF;AAKA;EAeI,kBAAA;AAjBJ;AAEA;EAmBI,uBAAA;AAlBJ;AAoBI;EAAA;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;EAjBJ;AACF;AARA;EA6BI,eAAA;EACA,mBAAA;EACA,iBAAA;AAlBJ;AAoBI;EAAA;IACE,eAAA;EAjBJ;AACF;AAlBA;EAuCI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlBJ;AAoBI;EAAA;IACE,eAAA;EAjBJ;AACF;AA7BA;EAkDI,2CAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,2BAAA;EACA,yBAAA;AAlBJ;AAoBI;EAAA;IACE,eAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,aAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,QAAA;IACA,0BAAA;EAjBJ;AACF;AAmBI;EAAA;IACE,eAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,aAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,QAAA;IACA,2CAAA;EAhBJ;AACF;AA5EA;EA+FM,eAAA;EACA,qBAAA;AAhBN;AAkBM;EAAA;IACE,eAAA;IACA,oBAAA;EAfN;AACF;AAtFA;EAyGM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,QAAA;AAhBN;AAkBM;EAAA;IACE,wBAAA;EAfN;AACF;AApGA;EAsHQ,WAAA;EACA,YAAA;EACA,sCAAA;AAfR;AAiBQ;EAAA;IACE,WAAA;IACA,YAAA;EAdR;AACF;AA/GA;EAmII,uBAAA;EAjBF,8BAA8B;EAkB5B,aAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;AAhBJ;AAkBI;EAAA;IACE,UAAA;IACA,WAAA;IACA,gBAAA;IACA,2BAAA;IACA,mBAAA;EAfJ;AACF;AApIA;EAsJM,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAfN;AA1IA;EA4JQ,eAAA;EACA,yBAAA;EACA,mBAAA;AAfR;AAiBQ;EAAA;IACE,eAAA;IACA,mBAAA;IACA,eAAA;EAdR;AACF;AAtJA;EAuKU,WAAA;EACA,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;AAdV;AAgBU;EAAA;IACE,gBAAA;EAbV;AACF;AAlKA;EAkLY,YAAA;AAbZ;AArKA;EAyLM,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAjBN;AAmBM;EAAA;IACE,sBAAA;IACA,WAAA;IACA,oBAAA;EAhBN;AACF;AAnLA;EAsMQ,YAAA;AAhBR;AAkBQ;EAAA;IACE,WAAA;EAfR;AACF;AA3LA;EA8MQ,6BAAA;EACA,iBAAA;EACA,kCAAA;AAhBR;AAsBA;EACE,iCAAA;EACA,iBAAA;EACA,uBAAA;AApBF;AAsBE;EAAA;IACE,eAAA;EAnBF;AACF;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAnBJ;AAqBI;EAAA;IACE,sBAAA;EAlBJ;AACF;AAoBI;EACE,eAAA;AAlBN;AAoBM;EAAA;IACE,kBAAA;EAjBN;AACF;AAGE;EAkBI,UAAA;EACA,YAAA;AAlBN;AAoBM;EAAA;IACE,WAAA;IACA,aAAA;EAjBN;AACF;AAPE;EA2BM,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAjBR;AAvBA;EA8CI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,YAAA;EACA,OAAA;AApBN;AAjCA;EAyDM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+CAAA;AArBN;AA5CA;EAqEM,eAAA;EACA,6BAAA;EACA,iBAAA;AAtBN;AAjDA;EA2EM,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAvBN;AAyBM;EAAA;IACE,eAAA;EAtBN;AACF;AAwBM;EAAA;IACE,eAAA;EArBN;AACF;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,+CAAA;EACA,eAAA;EAEA,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,wBAAA;EACA,iBAAA;EACA,aAAA;AAzBF;AAOA;EAqBI,SAAA;EACA,OAAA;AAzBJ;AAGA;EA0BI,gBAAA;EACA,0BAAA;AA1BJ;AADA;EA+BI,WAAA;EACA,kBAAA;EACA,sBAAA;AA3BJ;AA6BI;EAAA;IACE,kBAAA;EA1BJ;AACF;AA6BE;EAAA;IACE,sBAAA;IACA,kBAAA;EA1BF;AACF;AA6BA;EACE,aAAA;AA3BF;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,iCAAA;EACA,oBAAA;AA5BF;AA8BE;EAAA;IACE,eAAA;IACA,kBAAA;IACA,eAAA;EA3BF;AACF","sourcesContent":[":root {\n  --brand-color: #FF4900;\n  --primary-color: #FFFFFF;\n  --secondary-color: #6b6b6b;\n  --primary-bg-color: #000000;\n  --secondary-bg-color: #111111;\n  --bg-color: #060606;\n  --primary-border-color: #707070;\n  --secondary-border-color: #333333;\n  --filter-bg: none;\n}\n\n[data-theme=\"light\"] {\n  --primary-color: #000000;\n  --secondary-color: #444444;\n  --primary-bg-color: #FFFFFF;\n  --secondary-bg-color: #F5F5F5;\n  --bg-color: #FAFAFA;\n  --primary-border-color: #CCCCCC;\n  --secondary-border-color: #EEEEEE;\n  --filter-bg: grayscale(100%) brightness(100%);\n}\n\n@brand-color: var(--brand-color);\n@primary-color: var(--primary-color);\n@secondary-color: var(--secondary-color);\n@primary-bg-color: var(--primary-bg-color);\n@secondary-bg-color: var(--secondary-bg-color);\n@bg-color: var(--bg-color);\n@primary-border-color: var(--primary-border-color);\n@secondary-border-color: var(--secondary-border-color);\n\n@filter-bg: var(--filter-bg);\n\n@basic-width-desktop: 1510px;\n@breakpoint-tablet: 1024px;\n@breakpoint-mobile: 768px;\n\n@font-family: \"Poppins\", sans-serif;","@import \"./variables.less\";\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n}\n\n* {\n  transition: background-color 0.3s ease, color 0.3s ease,\n    border-color 0.3s ease, filter 0.3s ease;\n}\n\nbody {\n  background-color: @primary-bg-color;\n  color: @primary-color;\n  font-family: @font-family;\n  font-size: 18px;\n  line-height: 35px;\n}\n\na {\n  color: @primary-color;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.basic-container {\n  max-width: @basic-width-desktop;\n  padding: 0 30px;\n  margin: 0 auto;\n\n  @media (max-width: @breakpoint-tablet) {\n    padding: 0 20px;\n  }\n}\n\nsvg {\n  font-family: @font-family;\n  width: 200px;\n  height: 80px;\n\n  @media (max-width: @breakpoint-mobile) {\n    width: 150px;\n    height: 60px;\n  }\n}\n\nheader#top-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 120px;\n  position: relative;\n\n  @media (max-width: @breakpoint-tablet) {\n    height: 80px;\n    justify-content: space-between;\n  }\n\n  div#logo {\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n\n    @media (max-width: @breakpoint-tablet) {\n      align-items: center;\n    }\n  }\n\n  .burger-menu {\n    display: none;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 30px;\n    height: 25px;\n    cursor: pointer;\n    z-index: 1001;\n\n    @media (max-width: @breakpoint-tablet) {\n      display: flex;\n    }\n\n    span {\n      width: 100%;\n      height: 3px;\n      background-color: @primary-color;\n      transition: all 0.3s ease;\n    }\n\n    &.active {\n      span:nth-child(1) {\n        transform: translateY(8px) rotate(45deg);\n      }\n      span:nth-child(2) {\n        opacity: 0;\n      }\n      span:nth-child(3) {\n        transform: translateY(-8px) rotate(-45deg);\n      }\n    }\n  }\n\n  div#navigation-links {\n    flex-grow: 1;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    height: 100%;\n\n    @media (max-width: @breakpoint-tablet) {\n      position: fixed;\n      top: 0;\n      right: -100%;\n      width: 100%;\n      height: 100vh;\n      background-color: @primary-bg-color;\n      flex-direction: column;\n      justify-content: center;\n      transition: right 0.3s ease;\n      z-index: 1000;\n      padding: 50px 0;\n\n      &.active {\n        right: 0;\n      }\n    }\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      height: 100%;\n\n      @media (max-width: @breakpoint-tablet) {\n        flex-direction: column;\n        height: auto;\n        margin-bottom: 30px;\n      }\n\n      li {\n        width: 140px;\n        padding: 0 0 30px 0;\n        display: flex;\n        align-items: flex-end;\n        justify-content: center;\n\n        @media (max-width: @breakpoint-tablet) {\n          width: 100%;\n          padding: 20px 0;\n          align-items: center;\n        }\n\n        @media (max-width: @breakpoint-mobile) {\n          width: auto;\n          padding: 15px 0;\n        }\n\n        &.selected {\n          background-color: @brand-color;\n        }\n      }\n    }\n  }\n\n  #hire-me-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n\n    @media (max-width: @breakpoint-tablet) {\n      display: none; // Hide on mobile/tablet or move inside menu if needed\n    }\n  }\n\n  #language-selection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    height: 100%;\n    padding-top: 25px;\n    margin-left: 50px;\n    color: @secondary-color;\n\n    @media (max-width: @breakpoint-tablet) {\n      margin-left: 0;\n      padding-top: 0;\n      margin-bottom: 20px;\n      height: auto;\n    }\n\n    & span {\n      font-size: 18px;\n      cursor: pointer;\n\n      &:hover {\n        color: @primary-color;\n      }\n    }\n  }\n\n  #theme-selection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    padding-top: 35px;\n    margin-left: 20px;\n    color: @secondary-color;\n    cursor: pointer;\n    font-size: 18px;\n    width: 35px;\n    text-align: center;\n\n    @media (max-width: @breakpoint-tablet) {\n      margin-left: 0;\n      padding-top: 0;\n      height: auto;\n    }\n\n    &:hover {\n      color: @primary-color;\n    }\n  }\n}\n\nbutton {\n  border-radius: 10px;\n  border: 2px solid @brand-color;\n  background-color: @brand-color;\n  color: @primary-color;\n  width: 150px;\n  padding: 23px 0px;\n  align-self: flex-end;\n\n  @media (max-width: @breakpoint-mobile) {\n    width: 120px;\n    padding: 15px 0;\n    font-size: 14px;\n  }\n}\n\nbutton#hire-me-button {\n  margin-left: 35px;\n  margin-bottom: 5px;\n\n  @media (max-width: @breakpoint-mobile) {\n    margin-left: 10px;\n  }\n}\n\n#hero-section {\n  min-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n\n  @media (max-width: @breakpoint-tablet) {\n    min-height: auto;\n    padding: 100px 0;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  #hero-text {\n    flex: 1;\n    z-index: 1;\n  }\n\n  #hero-canvas-container {\n    flex: 1;\n    height: 600px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    @media (max-width: @breakpoint-tablet) {\n      height: 400px;\n      position: absolute;\n      z-index: -1;\n    }\n\n    @media (max-width: @breakpoint-mobile) {\n      height: 300px;\n    }\n\n    canvas {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  .annotation {\n    position: relative;\n    font-size: 24px;\n    margin-bottom: 10px;\n    width: 200px;\n    height: 50px;\n    text-align: center;\n    line-height: 50px;\n    background-color: @brand-color;\n\n    @media (max-width: @breakpoint-mobile) {\n      font-size: 18px;\n      width: 150px;\n      height: 40px;\n      line-height: 40px;\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      transform: translateY(-10%) translateX(-50%) rotate(90deg);\n\n      // triangle pointing right\n      width: 0;\n      height: 0;\n      border-top: 10px solid transparent;\n      border-bottom: 10px solid transparent;\n      border-left: 20px solid @brand-color; // match .annotation background\n    }\n  }\n\n  h1 {\n    font-size: 80px;\n    margin: 25px 0;\n\n    @media (max-width: @breakpoint-tablet) {\n      font-size: 60px;\n    }\n\n    @media (max-width: @breakpoint-mobile) {\n      font-size: 40px;\n    }\n  }\n  p {\n    font-size: 20px;\n    margin: 10px 0 30px 0;\n\n    @media (max-width: @breakpoint-mobile) {\n      font-size: 16px;\n    }\n  }\n\n  #scroll-down-indicator {\n    position: absolute;\n    bottom: 0px;\n    right: 50%;\n    transform: translateX(50%) translateY(-20%);\n\n    @media (max-width: @breakpoint-tablet) {\n      display: none;\n    }\n  }\n\n  // &::after {\n  //   content: \"\";\n  //   position: absolute;\n  //   top: 0;\n  //   right: 0;\n  //   width: 100%;\n  //   height: 100%;\n  //   background-image: url(\"../../asserts/man-wearing-black-bow-tie-2330079.png\");\n  //   background-size: cover;\n  //   background-position: center;\n  //   opacity: 1;\n  //   transform: translateX(50%);\n  //   z-index: -1;\n  //   filter: @filter-bg;\n\n  //   @media (max-width: @breakpoint-tablet) {\n  //     opacity: 0.3;\n  //     transform: translateX(0);\n  //   }\n  // }\n}\n\n#about-me {\n  padding: 200px 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: relative;\n\n  @media (max-width: @breakpoint-tablet) {\n    flex-direction: column;\n    padding: 100px 0;\n    align-items: center;\n  }\n\n  .picture {\n    position: relative;\n  }\n\n  img {\n    filter: grayscale(100%);\n\n    @media (max-width: @breakpoint-tablet) {\n      width: 100%;\n      max-width: 500px;\n      margin-bottom: 50px;\n    }\n  }\n\n  .title {\n    font-size: 36px;\n    margin-bottom: 20px;\n    font-weight: bold;\n\n    @media (max-width: @breakpoint-mobile) {\n      font-size: 28px;\n    }\n  }\n\n  p {\n    font-size: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n    line-height: 1.6;\n\n    @media (max-width: @breakpoint-mobile) {\n      font-size: 16px;\n    }\n  }\n\n  .experience-badge {\n    background-color: @secondary-bg-color;\n    color: @primary-color;\n    width: 220px;\n    height: 200px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    font-size: 40px;\n    font-weight: bold;\n    padding: 45px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-25%);\n    transition: all 0.3s ease;\n\n    @media (max-width: @breakpoint-tablet) {\n      transform: none;\n      margin: 30px 0;\n      width: 180px;\n      height: 160px;\n      padding: 30px;\n      font-size: 30px;\n      bottom: 0;\n      left: unset;\n      right: 0;\n      transform: translateX(25%);\n    }\n\n    @media (max-width: @breakpoint-mobile) {\n      transform: none;\n      margin: 30px 0;\n      width: 140px;\n      height: 120px;\n      padding: 20px;\n      font-size: 22px;\n      bottom: 0;\n      left: unset;\n      right: 0;\n      transform: translateX(-25%) translateY(25%);\n    }\n\n    h3 {\n      font-size: 50px;\n      margin: 30px 0 10px 0;\n\n      @media (max-width: @breakpoint-tablet) {\n        font-size: 40px;\n        margin: 20px 0 5px 0;\n      }\n    }\n\n    .dots-row {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      position: absolute;\n      width: calc(100% - 90px);\n      top: 0px;\n\n      @media (max-width: @breakpoint-tablet) {\n        width: calc(100% - 60px);\n      }\n\n      span {\n        width: 20px;\n        height: 45px;\n        background-color: @primary-color;\n\n        @media (max-width: @breakpoint-tablet) {\n          width: 15px;\n          height: 30px;\n        }\n      }\n    }\n  }\n\n  .skills {\n    scroll-margin-top: 80px; /* set to your header height */\n    display: flex;\n    height: 100%;\n    min-height: 100%;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 0 70px;\n\n    @media (max-width: @breakpoint-tablet) {\n      padding: 0;\n      width: 100%;\n      margin-top: 50px;\n      justify-content: flex-start;\n      align-items: center;\n    }\n\n    .skills-list {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      width: 100%;\n\n      .skill-item {\n        font-size: 20px;\n        text-transform: uppercase;\n        margin-bottom: 40px;\n\n        @media (max-width: @breakpoint-tablet) {\n          font-size: 16px;\n          margin-bottom: 25px;\n          padding: 0 25px;\n        }\n\n        .skill-bar {\n          width: 100%;\n          height: 5px;\n          background-color: @secondary-border-color;\n          overflow: hidden;\n          margin-top: 30px;\n\n          @media (max-width: @breakpoint-mobile) {\n            margin-top: 15px;\n          }\n\n          .skill-level {\n            height: 100%;\n          }\n        }\n      }\n    }\n\n    .button-section {\n      display: flex;\n      gap: 20px;\n      justify-content: flex-start;\n      align-items: center;\n      flex-grow: 1;\n\n      @media (max-width: @breakpoint-mobile) {\n        flex-direction: column;\n        width: 100%;\n        align-items: stretch;\n      }\n\n      button {\n        width: 240px;\n\n        @media (max-width: @breakpoint-mobile) {\n          width: 100%;\n        }\n      }\n\n      button.secondary-button {\n        background-color: transparent;\n        border: 2px solid;\n        border-color: @primary-color;\n      }\n    }\n  }\n}\n\n#contact-section {\n  background-color: @bg-color;\n  margin-top: 100px;\n  scroll-margin-top: 80px;\n\n  @media (max-width: @breakpoint-tablet) {\n    margin-top: 0px;\n  }\n\n  & > div:first-child {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    @media (max-width: @breakpoint-tablet) {\n      flex-direction: column;\n    }\n\n    & > section {\n      padding: 50px 0;\n\n      @media (max-width: @breakpoint-tablet) {\n        padding: 50px 20px;\n      }\n    }\n\n    .contact-image {\n      width: 50%;\n      height: auto;\n\n      @media (max-width: @breakpoint-tablet) {\n        width: 100%;\n        height: 300px;\n      }\n\n      img {\n        object-fit: cover;\n        object-position: center;\n        filter: grayscale(100%);\n        height: 100%;\n        width: 100%;\n      }\n    }\n  }\n\n  .contact-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 30px;\n\n    & > div:last-child {\n      min-width: 0;\n      flex: 1;\n    }\n\n    .contact-icon {\n      width: 20px;\n      height: 20px;\n      margin-right: 20px;\n      padding: 10px;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border: 2px solid @secondary-border-color;\n    }\n\n    .contact-title {\n      font-size: 18px;\n      color: @secondary-color;\n      line-height: 18px;\n    }\n\n    .contact-text {\n      font-size: 25px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      max-width: 100%;\n      line-height: 1.4;\n\n      @media (max-width: @breakpoint-mobile) {\n        font-size: 18px;\n      }\n\n      @media (max-width: 360px) {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.policy-notice {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-top: 60px;\n  padding: 30px;\n  border-radius: 12px;\n  background-color: @secondary-bg-color;\n  border: 1px solid @secondary-border-color;\n  font-size: 18px;\n\n  position: fixed;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: calc(100% - 60px);\n  max-width: @basic-width-desktop;\n  z-index: 1000;\n\n  p {\n    margin: 0;\n    flex: 1;\n  }\n\n  a {\n    font-weight: 600;\n    text-decoration: underline;\n  }\n\n  button[data-policy-ack] {\n    width: auto;\n    padding: 12px 32px;\n    align-self: flex-start;\n\n    @media (max-width: @breakpoint-mobile) {\n      align-self: center;\n    }\n  }\n\n  @media (max-width: @breakpoint-tablet) {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n.policy-notice--hidden {\n  display: none;\n}\n\nfooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n  background-color: @bg-color;\n  font-weight: lighter;\n\n  @media (max-width: @breakpoint-mobile) {\n    font-size: 14px;\n    text-align: center;\n    padding: 0 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
